module.exports = __webpack_public_path__ + "img/logo-aloft.22574900.png";